module.exports = {
          srcSet: __webpack_public_path__ + "bab439c5.jpg"+" 700w"+","+__webpack_public_path__ + "fc0ec78b.jpg"+" 1400w"+","+__webpack_public_path__ + "0571845b.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "bab439c5.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "fc0ec78b.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "0571845b.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "bab439c5.jpg",
          toString:function(){return __webpack_public_path__ + "bab439c5.jpg"},
          
          width: 700,
          height: 467
        }